import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import DropDownStyles, { DropDownStylesDark } from "../staff/dropdownStyles.js";
import useDarkMode from "../../hooks/useDarkMode.js";
import useThemeColor from "../../hooks/useThemeColor.js";

const AddUpdateAllergenModal = ({
  show,
  onHide,
  onSubmit,
  isEdit,
  allergen,
}) => {
  const isDarkMode = useDarkMode();
  const themeColor = useThemeColor();
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    sortOrder: 0,
  });
  const [errors, setErrors] = useState({});


  useEffect(() => {
    if (isEdit && allergen) {
      setFormData({
        name: allergen.allergen_Name || "",
        description: allergen.allergen_Description || "",
        sortOrder: allergen.allergen_SortOrder || 0,
      });
    } else {
      setFormData({
        name: "",
        description: "",
        sortOrder: 0,
      });
    }
    setErrors({});
  }, [isEdit, allergen]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSelectChange = (selectedOption, field) => {
    setFormData((prev) => ({
      ...prev,
      [field]: selectedOption,
    }));
    
    // Clear error when user makes selection
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (formData.sortOrder < 0) {
      newErrors.sortOrder = "Sort order must be a positive number";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const submitData = {
      ID: allergen ? allergen.ID : 0,
      name: formData.name.trim(),
      description: formData.description.trim(),
      sortOrder: parseInt(formData.sortOrder) || 0,
    };
    onSubmit(submitData, isEdit, false);
  };

  const handleClose = () => {
    setFormData({
      name: "",
      description: "",
      sortOrder: 0,
    });
    setErrors({});
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>
          {isEdit ? "Edit Allergen" : "Add New Allergen"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Enter allergen name"
                  isInvalid={!!errors.name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  type="text"
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  placeholder="Enter allergen description"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Sort Order</Form.Label>
                <Form.Control
                  type="number"
                  name="sortOrder"
                  value={formData.sortOrder}
                  onChange={handleInputChange}
                  placeholder="Enter sort order"
                  min="0"
                  isInvalid={!!errors.sortOrder}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.sortOrder}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          style={{
            backgroundColor: themeColor,
            borderColor: themeColor,
          }}
        >
          {isEdit ? "Update Allergen" : "Add Allergen"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddUpdateAllergenModal;
